import { gql } from '@apollo/client';

const CLINIC_EVENTS_QUERY = gql`
  query clinicEvents($filter: ClinicEventFilterInput, $limit: Int) {
    clinicEvents(filter: $filter, limit: $limit) {
      id
      friendlyId
      type
      start
      reason
      comments
      study {
        id
        status
        timezone
      }
      stripImgs
      realtimeData {
        start
      }
    }
  }
`;

export default CLINIC_EVENTS_QUERY;
